import { uniq, remove } from 'lodash';
import {
  REQUEST_ACCOUNT_LIST_SUCCESS,
  REQUEST_ACCOUNT_LIST_FAILURE,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_ACCOUNT_FAILURE,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE
} from '../constants/actionTypes';

const INITIAL_STATE = { ids: [], error: null, isLoading: true };

export default function socialAccount(state = INITIAL_STATE, action) {
  
  switch (action.type) {
    case REQUEST_ACCOUNT_LIST_SUCCESS:
      console.log("accmanagerred1",action.payload)
      return {
        ids: action.payload.data.map(data => parseInt(data.id, 10)),
        isLoading: false,
        error: null
      };
    case REQUEST_ACCOUNT_LIST_FAILURE:
      console.log("accmanagerred2",action.payload)
      return {
        ...state,
        ids: [],
        isLoading: false,
        error: action?.payload?.message
      };
    case CREATE_ACCOUNT_SUCCESS:

      // return {
      //   ...state,
      //   ids: uniq([...state.ids, parseInt(action.payload.data.id, 10)]),
      //   error: null
      // };
      return {
        ids: action.payload.data.map(data => parseInt(data.id, 10)),
        error: null
      };
    case CREATE_ACCOUNT_FAILURE:
      return {
        ...state,
        error: action?.payload?.message
      };
    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        ids: remove(state.ids, key => key !== parseInt(action.payload.id, 10)),
        error: null
      };
    case DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        error: action?.payload?.message
      };
    default:
      return state;
  }
}
